import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { AppState } from "src/app/shared/models/store models/app-state.interface";
import { PermissionAdmin } from "../shared/models/admin.permission.model";
import { SinglePermissionModel } from "../shared/models/IPermission";
import { PermissionsServiceService } from "../shared/services/permissions-service.service";
import {
  getViewModleForPermissions,
  setSelectAllAdminStatus,
} from "./permissions-admin.mapper";
import {
  getACLicenseStatus,
  getCurrentTenant,
  getLTLicenseStatus,
} from "src/app/state/index";
import { ViewMode } from "src/app/shared/enums/view-mode.enum";
import { TranslationLoaderFacade } from "../../localization/translation-loader.facade";

@Component({
  selector: "app-permissions-admin",
  templateUrl: "./permissions-admin.component.html",
  styleUrls: ["./permissions-admin.component.scss"],
})
export class PermissionsAdminComponent implements OnInit, OnDestroy {
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  private _allPermissionInCategory: { data: any[]; groupPermission: number[] } =
    { data: [], groupPermission: [] };
  @Input() set allPermissionsInCategory(value: {
    data: any[];
    groupPermission: number[];
  }) {
    this._allPermissionInCategory = value;
    this.updatModlesFromBackEnd(this._allPermissionInCategory?.data ?? []);
  }
  @Output() AdminObject: EventEmitter<PermissionAdmin> =
    new EventEmitter<PermissionAdmin>();
  public permissionAdmin: PermissionAdmin = new PermissionAdmin();
  public initialPermissionAdminState: PermissionAdmin = new PermissionAdmin();
  isACLicenseEnabled$: Observable<boolean> = new Observable<boolean>();
  isLTLicenseEnabled$: Observable<boolean> = new Observable<boolean>();
  isLoaded: boolean = false;

  permissionSubscriptions = new Subscription();
  tenantId: number = 0;

  @Input() isViewOnly: boolean = false;
  @Input() isUkgDefaultGroup: boolean = false;
  public isAdminSelectAll: boolean = false;
  @Output() sectionSelectAll = new EventEmitter<boolean>(false);
  public disabledSelectAllAdmin: boolean = true;

  constructor(
    public permissionService: PermissionsServiceService,
    private store: Store<AppState>,
    private translationLoaderFacade: TranslationLoaderFacade
  ) {}

  ngOnInit(): void {
    this.isLTLicenseEnabled$ = this.store.select(getLTLicenseStatus);
    this.isACLicenseEnabled$ = this.store.select(getACLicenseStatus);

    const tenantSelectionSub = this.store
      .select(getCurrentTenant)
      .subscribe((tenant) => {
        if (tenant) {
          this.tenantId = tenant.tenantID;
        }
      });
    this.permissionSubscriptions.add(tenantSelectionSub);
  }

  private updatModlesFromBackEnd(modle: SinglePermissionModel[]) {
    this.permissionService
      .getEdittingPermissionCategory()
      .subscribe((isEditting) => {
        if (isEditting) {
          this.setedditingParams(modle, isEditting.viewMode);
        } else {
          this.setAddParams(modle);
        }
        this.initialPermissionAdminState = JSON.parse(
          JSON.stringify(this.permissionAdmin)
        );
        this.publishUpdatedObject(false);
      });
  }

  checkSelectAllPermission(isSelectAllEnabled: boolean) {
    if (isSelectAllEnabled) {
      this.changeSelectAllAdmin();
    } else {
      this.permissionAdmin.selectAllPermissionAdmin.Selected = false;
      this.sectionSelectAll.emit(false);
    }
  }

  onAdminKioskItemChange() {
    this.permissionAdmin.Kiosk.selectAll =
      this.permissionAdmin.Kiosk.viewKioskConfiguration.Selected &&
      this.permissionAdmin.Kiosk.addKioskConfiguration.Selected &&
      this.permissionAdmin.Kiosk.editKioskConfiguration.Selected &&
      this.permissionAdmin.Kiosk.deleteKioskConfiguration.Selected;
    this.changeSelectAllAdmin();
    this.handleKioskChildElements();
    this.publishUpdatedObject();
  }
  selectAllKiosk() {
    this.permissionAdmin.Kiosk.viewKioskConfiguration.Selected =
      this.permissionAdmin.Kiosk.viewKioskConfiguration.Selected &&
      !this.permissionAdmin.Kiosk.viewKioskConfiguration.Enabled
        ? true
        : this.permissionAdmin.Kiosk.selectAll &&
          this.permissionAdmin.Kiosk.viewKioskConfiguration.Enabled;
    this.permissionAdmin.Kiosk.addKioskConfiguration.Selected =
      this.permissionAdmin.Kiosk.addKioskConfiguration.Selected &&
      !this.permissionAdmin.Kiosk.addKioskConfiguration.Enabled
        ? true
        : this.permissionAdmin.Kiosk.selectAll &&
          this.permissionAdmin.Kiosk.addKioskConfiguration.Enabled;
    this.permissionAdmin.Kiosk.editKioskConfiguration.Selected =
      this.permissionAdmin.Kiosk.editKioskConfiguration.Selected &&
      !this.permissionAdmin.Kiosk.editKioskConfiguration.Enabled
        ? true
        : this.permissionAdmin.Kiosk.selectAll &&
          this.permissionAdmin.Kiosk.editKioskConfiguration.Enabled;
    this.permissionAdmin.Kiosk.deleteKioskConfiguration.Selected =
      this.permissionAdmin.Kiosk.deleteKioskConfiguration.Selected &&
      !this.permissionAdmin.Kiosk.deleteKioskConfiguration.Enabled
        ? true
        : this.permissionAdmin.Kiosk.selectAll &&
          this.permissionAdmin.Kiosk.deleteKioskConfiguration.Enabled;
    this.checkSelectAllPermission(this.permissionAdmin.Kiosk.selectAll);
    this.publishUpdatedObject();
  }
  handleKioskChildElements() {
    const kiosk = this.permissionAdmin.Kiosk;
    if (!kiosk.viewKioskConfiguration.Selected) {
      kiosk.addKioskConfiguration.Selected = false;
      kiosk.editKioskConfiguration.Selected = false;
      kiosk.deleteKioskConfiguration.Selected = false;
    }
  }

  onAdminGlobalAlertItemChange() {
    this.permissionAdmin.ViewGlobalAlerts.selectAll =
      this.permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Selected &&
      this.permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Selected &&
      this.permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Selected &&
      this.permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Selected &&
      this.permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts.Selected;
    this.changeSelectAllAdmin();
    this.handleGlobalAlertChildElements();
    this.publishUpdatedObject();
  }
  handleGlobalAlertChildElements() {
    const alert = this.permissionAdmin.ViewGlobalAlerts;
    if (!alert.viewGlobalAlerts.Selected) {
      alert.addGlobalAlerts.Selected = false;
      alert.editGlobalAlerts.Selected = false;
      alert.deleteGlobalAlerts.Selected = false;
    }
  }

  selectAllGlobalAlert() {
    this.permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Selected =
      this.permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Selected &&
      !this.permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Enabled
        ? true
        : this.permissionAdmin.ViewGlobalAlerts.selectAll &&
          this.permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Enabled;
    this.permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Selected =
      this.permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Selected &&
      !this.permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Enabled
        ? true
        : this.permissionAdmin.ViewGlobalAlerts.selectAll &&
          this.permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Enabled;
    this.permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Selected =
      this.permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Selected &&
      !this.permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Enabled
        ? true
        : this.permissionAdmin.ViewGlobalAlerts.selectAll &&
          this.permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Enabled;
    this.permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Selected =
      this.permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Selected &&
      !this.permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Enabled
        ? true
        : this.permissionAdmin.ViewGlobalAlerts.selectAll &&
          this.permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Enabled;
    this.permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts.Selected =
      this.permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts
        .Selected &&
      !this.permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts.Enabled
        ? true
        : this.permissionAdmin.ViewGlobalAlerts.selectAll &&
          this.permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts
            .Enabled;
    this.checkSelectAllPermission(
      this.permissionAdmin.ViewGlobalAlerts.selectAll
    );
    this.publishUpdatedObject();
  }

  onAdminClientsItemChange() {
    this.permissionAdmin.Clients.selectAll =
      this.permissionAdmin.Clients.viewClients.Selected &&
      this.permissionAdmin.Clients.addClients.Selected &&
      this.permissionAdmin.Clients.changeClients.Selected;
    this.changeSelectAllAdmin();
    this.publishUpdatedObject();
  }

  selectAllClients() {
    if (this.tenantId == 1 && this.isUkgDefaultGroup) {
      this.permissionAdmin.Clients.viewClients.Selected =
        this.permissionAdmin.Clients.viewClients.Selected &&
        !this.permissionAdmin.Clients.viewClients.Enabled
          ? true
          : this.permissionAdmin.Clients.selectAll &&
            this.permissionAdmin.Clients.viewClients.Enabled;
      this.permissionAdmin.Clients.addClients.Selected =
        this.permissionAdmin.Clients.addClients.Selected &&
        !this.permissionAdmin.Clients.addClients.Enabled
          ? true
          : this.permissionAdmin.Clients.selectAll &&
            this.permissionAdmin.Clients.addClients.Enabled;
      this.permissionAdmin.Clients.changeClients.Selected =
        this.permissionAdmin.Clients.changeClients.Selected &&
        !this.permissionAdmin.Clients.changeClients.Enabled
          ? true
          : this.permissionAdmin.Clients.selectAll &&
            this.permissionAdmin.Clients.changeClients.Enabled;
      this.checkSelectAllPermission(this.permissionAdmin.Clients.selectAll);
      this.publishUpdatedObject();
    }
  }

  onAdminUMembersItemChange() {
    this.permissionAdmin.Members.selectAll =
      this.permissionAdmin.Members.viewMembers.Selected &&
      this.permissionAdmin.Members.importMembers.Selected;
    this.changeSelectAllAdmin();
    this.publishUpdatedObject();
  }

  selectAllMembers() {
    this.permissionAdmin.Members.viewMembers.Selected =
      this.permissionAdmin.Members.viewMembers.Selected &&
      !this.permissionAdmin.Members.viewMembers.Enabled
        ? true
        : this.permissionAdmin.Members.selectAll &&
          this.permissionAdmin.Members.viewMembers.Enabled;
    this.permissionAdmin.Members.importMembers.Selected =
      this.permissionAdmin.Members.importMembers.Selected &&
      !this.permissionAdmin.Members.importMembers.Enabled
        ? true
        : this.permissionAdmin.Members.selectAll &&
          this.permissionAdmin.Members.importMembers.Enabled;
    this.checkSelectAllPermission(this.permissionAdmin.Members.selectAll);
    this.publishUpdatedObject();
  }

  onAdminUsersItemChange() {
    this.permissionAdmin.Users.selectAll =
      this.permissionAdmin.Users.viewUsers.Selected &&
      this.permissionAdmin.Users.addUsers.Selected &&
      this.permissionAdmin.Users.editUsers.Selected &&
      this.permissionAdmin.Users.deleteUsers.Selected;
    this.changeSelectAllAdmin();
    this.handleUserChildElements();
    this.publishUpdatedObject();
  }
  handleUserChildElements() {
    const user = this.permissionAdmin.Users;
    if (!user.viewUsers.Selected) {
      user.addUsers.Selected = false;
      user.editUsers.Selected = false;
      user.deleteUsers.Selected = false;
    }
  }

  selectAllUsers() {
    this.permissionAdmin.Users.viewUsers.Selected =
      this.permissionAdmin.Users.viewUsers.Selected &&
      !this.permissionAdmin.Users.viewUsers.Enabled
        ? true
        : this.permissionAdmin.Users.selectAll &&
          this.permissionAdmin.Users.viewUsers.Enabled;
    this.permissionAdmin.Users.addUsers.Selected =
      this.permissionAdmin.Users.addUsers.Selected &&
      !this.permissionAdmin.Users.addUsers.Enabled
        ? true
        : this.permissionAdmin.Users.selectAll &&
          this.permissionAdmin.Users.addUsers.Enabled;
    this.permissionAdmin.Users.editUsers.Selected =
      this.permissionAdmin.Users.editUsers.Selected &&
      !this.permissionAdmin.Users.editUsers.Enabled
        ? true
        : this.permissionAdmin.Users.selectAll &&
          this.permissionAdmin.Users.editUsers.Enabled;
    this.permissionAdmin.Users.deleteUsers.Selected =
      this.permissionAdmin.Users.deleteUsers.Selected &&
      !this.permissionAdmin.Users.deleteUsers.Enabled
        ? true
        : this.permissionAdmin.Users.selectAll &&
          this.permissionAdmin.Users.deleteUsers.Enabled;
    this.checkSelectAllPermission(this.permissionAdmin.Users.selectAll);
    this.publishUpdatedObject();
  }

  onAdminGroupsItemChange() {
    this.permissionAdmin.Groups.selectAll =
      this.permissionAdmin.Groups.viewPermissionGroups.Selected &&
      this.permissionAdmin.Groups.addPermissionGroups.Selected &&
      this.permissionAdmin.Groups.editPermissionGroups.Selected &&
      this.permissionAdmin.Groups.deletePermissionGroups.Selected;
    this.changeSelectAllAdmin();
    this.handleAdminChildElements();
    this.publishUpdatedObject();
  }
  handleAdminChildElements() {
    const admin = this.permissionAdmin.Groups;
    if (!admin.viewPermissionGroups.Selected) {
      admin.addPermissionGroups.Selected = false;
      admin.editPermissionGroups.Selected = false;
      admin.deletePermissionGroups.Selected = false;
    }
  }

  selectAllGroups() {
    this.permissionAdmin.Groups.viewPermissionGroups.Selected =
      this.permissionAdmin.Groups.viewPermissionGroups.Selected &&
      !this.permissionAdmin.Groups.viewPermissionGroups.Enabled
        ? true
        : this.permissionAdmin.Groups.selectAll &&
          this.permissionAdmin.Groups.viewPermissionGroups.Enabled;
    this.permissionAdmin.Groups.addPermissionGroups.Selected =
      this.permissionAdmin.Groups.addPermissionGroups.Selected &&
      !this.permissionAdmin.Groups.addPermissionGroups.Enabled
        ? true
        : this.permissionAdmin.Groups.selectAll &&
          this.permissionAdmin.Groups.addPermissionGroups.Enabled;
    this.permissionAdmin.Groups.editPermissionGroups.Selected =
      this.permissionAdmin.Groups.editPermissionGroups.Selected &&
      !this.permissionAdmin.Groups.editPermissionGroups.Enabled
        ? true
        : this.permissionAdmin.Groups.selectAll &&
          this.permissionAdmin.Groups.editPermissionGroups.Enabled;
    this.permissionAdmin.Groups.deletePermissionGroups.Selected =
      this.permissionAdmin.Groups.deletePermissionGroups.Selected &&
      !this.permissionAdmin.Groups.deletePermissionGroups.Enabled
        ? true
        : this.permissionAdmin.Groups.selectAll &&
          this.permissionAdmin.Groups.deletePermissionGroups.Enabled;
    this.checkSelectAllPermission(this.permissionAdmin.Groups.selectAll);
    this.publishUpdatedObject();
  }

  onAdminProductAndServiceItemChange() {
    this.permissionAdmin.ProductAndService.selectAll =
      this.permissionAdmin.ProductAndService.viewProductsServices.Selected &&
      this.permissionAdmin.ProductAndService.addProductsServices.Selected &&
      this.permissionAdmin.ProductAndService.editProductsAndServices.Selected &&
      this.permissionAdmin.ProductAndService.editBasicProductAndServices
        .Selected &&
      this.permissionAdmin.ProductAndService.activateDeactivateProductsServices
        .Selected &&
      this.permissionAdmin.ProductAndService.deleteProductsServices.Selected;

    this.changeSelectAllAdmin();
    this.handleProductAndServiceChildElements();
    this.publishUpdatedObject();
  }

  selectAllProductAndService() {
    this.permissionAdmin.ProductAndService.viewProductsServices.Selected =
      this.permissionAdmin.ProductAndService.viewProductsServices.Selected &&
      !this.permissionAdmin.ProductAndService.viewProductsServices.Enabled
        ? true
        : this.permissionAdmin.ProductAndService.selectAll &&
          this.permissionAdmin.ProductAndService.viewProductsServices.Enabled;
    this.permissionAdmin.ProductAndService.addProductsServices.Selected =
      this.permissionAdmin.ProductAndService.addProductsServices.Selected &&
      !this.permissionAdmin.ProductAndService.addProductsServices.Enabled
        ? true
        : this.permissionAdmin.ProductAndService.selectAll &&
          this.permissionAdmin.ProductAndService.addProductsServices.Enabled;
    this.permissionAdmin.ProductAndService.editBasicProductAndServices.Selected =
      this.permissionAdmin.ProductAndService.editBasicProductAndServices
        .Selected &&
      !this.permissionAdmin.ProductAndService.editBasicProductAndServices
        .Enabled
        ? true
        : this.permissionAdmin.ProductAndService.selectAll &&
          this.permissionAdmin.ProductAndService.editBasicProductAndServices
            .Enabled;
    this.permissionAdmin.ProductAndService.editProductsAndServices.Selected =
      this.permissionAdmin.ProductAndService.editProductsAndServices.Selected &&
      !this.permissionAdmin.ProductAndService.editProductsAndServices.Enabled
        ? true
        : this.permissionAdmin.ProductAndService.selectAll &&
          this.permissionAdmin.ProductAndService.editProductsAndServices
            .Enabled;
    this.permissionAdmin.ProductAndService.activateDeactivateProductsServices.Selected =
      this.permissionAdmin.ProductAndService.activateDeactivateProductsServices
        .Selected &&
      !this.permissionAdmin.ProductAndService.activateDeactivateProductsServices
        .Enabled
        ? true
        : this.permissionAdmin.ProductAndService.selectAll &&
          this.permissionAdmin.ProductAndService
            .activateDeactivateProductsServices.Enabled;
    this.permissionAdmin.ProductAndService.deleteProductsServices.Selected =
      this.permissionAdmin.ProductAndService.deleteProductsServices.Selected &&
      !this.permissionAdmin.ProductAndService.deleteProductsServices.Enabled
        ? true
        : this.permissionAdmin.ProductAndService.selectAll &&
          this.permissionAdmin.ProductAndService.deleteProductsServices.Enabled;
    this.checkSelectAllPermission(
      this.permissionAdmin.ProductAndService.selectAll
    );
    this.publishUpdatedObject();
  }
  handleProductAndServiceChildElements() {
    const service = this.permissionAdmin.ProductAndService;
    if (!service.viewProductsServices.Selected) {
      service.addProductsServices.Selected = false;
      service.editBasicProductAndServices.Selected = false;
      service.editProductsAndServices.Selected = false;
      service.activateDeactivateProductsServices.Selected = false;
      service.deleteProductsServices.Selected = false;
    }
    if (!service.editProductsAndServices.Selected) {
      service.editBasicProductAndServices.Selected = false;
    }
  }

  onAdminViewAddEditProductCategoriesItemChange() {
    this.permissionAdmin.ViewAddEditDeleteProductCategory.selectAll =
      this.permissionAdmin.ViewAddEditDeleteProductCategory.viewAddEditDeleteProductCategory.Selected;

    this.changeSelectAllAdmin();
    this.publishUpdatedObject();
  }

  selectAllViewAddEditProductCategories() {
    this.permissionAdmin.ViewAddEditDeleteProductCategory.viewAddEditDeleteProductCategory.Selected =
      this.permissionAdmin.ViewAddEditDeleteProductCategory
        .viewAddEditDeleteProductCategory.Selected &&
      !this.permissionAdmin.ViewAddEditDeleteProductCategory
        .viewAddEditDeleteProductCategory.Enabled
        ? true
        : this.permissionAdmin.ViewAddEditDeleteProductCategory.selectAll &&
          this.permissionAdmin.ViewAddEditDeleteProductCategory
            .viewAddEditDeleteProductCategory.Enabled;
    this.checkSelectAllPermission(
      this.permissionAdmin.ViewAddEditDeleteProductCategory.selectAll
    );
    this.publishUpdatedObject();
  }

  public publishUpdatedObject(emitDirty: boolean = true) {
    if (
      emitDirty &&
      JSON.stringify(this.permissionAdmin) !==
        JSON.stringify(this.initialPermissionAdminState)
    ) {
      this.dirtyEmitter.emit(true);
    } else {
      this.dirtyEmitter.emit(false);
    }
    this.AdminObject.emit(this.permissionAdmin);
  }

  onAdminGeneralItemChange() {
    this.permissionAdmin.General.selectAll =
      this.permissionAdmin.General.viewEditLocalization.Selected &&
      this.permissionAdmin.General.viewEditSystemConfiguration.Selected &&
      this.permissionAdmin.General.dataImportExport.Selected &&
      //&& this.permissionAdmin.General.viewEditLicensing.Selected
      (this.tenantId == 1 && this.isUkgDefaultGroup
        ? this.permissionAdmin.General.viewEditLicensing.Selected
        : true);

    this.changeSelectAllAdmin();

    this.publishUpdatedObject();
  }

  selectAllGeneral() {
    this.permissionAdmin.General.viewEditSystemConfiguration.Selected =
      this.permissionAdmin.General.viewEditSystemConfiguration.Selected &&
      !this.permissionAdmin.General.viewEditSystemConfiguration.Enabled
        ? true
        : this.permissionAdmin.General.selectAll &&
          this.permissionAdmin.General.viewEditSystemConfiguration.Enabled;
    this.permissionAdmin.General.viewEditLocalization.Selected =
      this.permissionAdmin.General.viewEditLocalization.Selected &&
      !this.permissionAdmin.General.viewEditLocalization.Enabled
        ? true
        : this.permissionAdmin.General.selectAll &&
          this.permissionAdmin.General.viewEditLocalization.Enabled;
    this.permissionAdmin.General.dataImportExport.Selected =
      this.permissionAdmin.General.dataImportExport.Selected &&
      !this.permissionAdmin.General.dataImportExport.Enabled
        ? true
        : this.permissionAdmin.General.selectAll &&
          this.permissionAdmin.General.dataImportExport.Enabled;
    this.checkSelectAllPermission(this.permissionAdmin.General.selectAll);
    this.publishUpdatedObject();
  }

  onAdminLocationItemChange() {
    this.permissionAdmin.Location.selectAll =
      this.permissionAdmin.Location.viewLocations.Selected &&
      this.permissionAdmin.Location.editLocations.Selected &&
      this.permissionAdmin.Location.addLocations.Selected &&
      this.permissionAdmin.Location.activateDeactivateLocations.Selected &&
      this.permissionAdmin.Location.viewLocations.Selected;
    this.changeSelectAllAdmin();
    this.handleLocationChildElements();
    this.publishUpdatedObject();
  }
  handleLocationChildElements() {
    const location = this.permissionAdmin.Location;
    if (!location.viewLocations.Selected) {
      location.editLocations.Selected = false;
      location.addLocations.Selected = false;
      location.activateDeactivateLocations.Selected = false;
    }
  }

  selectAllLocations() {
    this.permissionAdmin.Location.viewLocations.Selected =
      this.permissionAdmin.Location.viewLocations.Selected &&
      !this.permissionAdmin.Location.viewLocations.Enabled
        ? true
        : this.permissionAdmin.Location.selectAll &&
          this.permissionAdmin.Location.viewLocations.Enabled;
    this.permissionAdmin.Location.editLocations.Selected =
      this.permissionAdmin.Location.editLocations.Selected &&
      !this.permissionAdmin.Location.editLocations.Enabled
        ? true
        : this.permissionAdmin.Location.selectAll &&
          this.permissionAdmin.Location.editLocations.Enabled;
    this.permissionAdmin.Location.addLocations.Selected =
      this.permissionAdmin.Location.addLocations.Selected &&
      !this.permissionAdmin.Location.addLocations.Enabled
        ? true
        : this.permissionAdmin.Location.selectAll &&
          this.permissionAdmin.Location.addLocations.Enabled;
    this.permissionAdmin.Location.activateDeactivateLocations.Selected =
      this.permissionAdmin.Location.activateDeactivateLocations.Selected &&
      !this.permissionAdmin.Location.activateDeactivateLocations.Enabled
        ? true
        : this.permissionAdmin.Location.selectAll &&
          this.permissionAdmin.Location.activateDeactivateLocations.Enabled;
    this.checkSelectAllPermission(this.permissionAdmin.Location.selectAll);
    this.publishUpdatedObject();
  }

  ngOnDestroy() {
    this.permissionAdmin = new PermissionAdmin();
    this.permissionSubscriptions.unsubscribe();
  }

  setedditingParams(model: SinglePermissionModel[], viewMode: number) {
    this.permissionAdmin = getViewModleForPermissions(
      model,
      viewMode,
      this._allPermissionInCategory.groupPermission,
      this.tenantId,
      this.isUkgDefaultGroup
    );
    this.disabledSelectAllAdmin = setSelectAllAdminStatus(this.permissionAdmin);
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  setAddParams(model: SinglePermissionModel[]) {
    this.permissionAdmin = getViewModleForPermissions(model, ViewMode.Add);
    this.disabledSelectAllAdmin = setSelectAllAdminStatus(this.permissionAdmin);
    if (model.length > 0) {
      this.isLoaded = true;
    }
  }

  valueChangeByselectAllPermissionsAdmin(e: Event) {
    const target = e.target as HTMLInputElement;
    this.valueChangeByselectAllPermissionsAdminCommon(target.checked);
    this.sectionSelectAll.emit(target.checked);
  }

  valueChangeByselectAllPermissionsAdminCommon(isEnable: boolean) {
    if (
      this.permissionAdmin.General.viewEditSystemConfiguration.Enabled &&
      this.permissionAdmin.General.viewEditLocalization.Enabled &&
      this.permissionAdmin.General.dataImportExport.Enabled
    )
      this.permissionAdmin.General.selectAll = isEnable;

    if (
      this.permissionAdmin.Clients.viewClients.Enabled &&
      this.permissionAdmin.Clients.addClients.Enabled &&
      this.permissionAdmin.Clients.changeClients.Enabled
    )
      this.permissionAdmin.Clients.selectAll = isEnable;

    if (
      this.permissionAdmin.Groups.viewPermissionGroups.Enabled &&
      this.permissionAdmin.Groups.addPermissionGroups.Enabled &&
      this.permissionAdmin.Groups.editPermissionGroups.Enabled &&
      this.permissionAdmin.Groups.deletePermissionGroups.Enabled
    )
      this.permissionAdmin.Groups.selectAll = isEnable;

    if (
      this.permissionAdmin.Kiosk.viewKioskConfiguration.Enabled &&
      this.permissionAdmin.Kiosk.addKioskConfiguration.Enabled &&
      this.permissionAdmin.Kiosk.editKioskConfiguration.Enabled &&
      this.permissionAdmin.Kiosk.deleteKioskConfiguration.Enabled
    )
      this.permissionAdmin.Kiosk.selectAll = isEnable;

    if (
      this.permissionAdmin.Location.editLocations.Enabled &&
      this.permissionAdmin.Location.addLocations.Enabled &&
      this.permissionAdmin.Location.viewLocations.Enabled &&
      this.permissionAdmin.Location.activateDeactivateLocations.Enabled
    )
      this.permissionAdmin.Location.selectAll = isEnable;

    if (
      this.permissionAdmin.ProductAndService.viewProductsServices.Enabled &&
      this.permissionAdmin.ProductAndService.addProductsServices.Enabled &&
      this.permissionAdmin.ProductAndService.editProductsAndServices.Enabled &&
      this.permissionAdmin.ProductAndService.editBasicProductAndServices
        .Enabled &&
      this.permissionAdmin.ProductAndService.activateDeactivateProductsServices
        .Enabled &&
      this.permissionAdmin.ProductAndService.deleteProductsServices.Enabled
    )
      this.permissionAdmin.ProductAndService.selectAll = isEnable;

    if (
      this.permissionAdmin.Users.viewUsers.Enabled &&
      this.permissionAdmin.Users.addUsers.Enabled &&
      this.permissionAdmin.Users.editUsers.Enabled &&
      this.permissionAdmin.Users.deleteUsers.Enabled
    )
      this.permissionAdmin.Users.selectAll = isEnable;

    if (
      this.permissionAdmin.ViewAddEditDeleteProductCategory
        .viewAddEditDeleteProductCategory.Enabled
    )
      this.permissionAdmin.ViewAddEditDeleteProductCategory.selectAll =
        isEnable;

    if (
      this.permissionAdmin.ViewGlobalAlerts.viewGlobalAlerts.Enabled &&
      this.permissionAdmin.ViewGlobalAlerts.addGlobalAlerts.Enabled &&
      this.permissionAdmin.ViewGlobalAlerts.editGlobalAlerts.Enabled &&
      this.permissionAdmin.ViewGlobalAlerts.deleteGlobalAlerts.Enabled &&
      this.permissionAdmin.ViewGlobalAlerts.viewAddEditDeleteMyAlerts.Enabled
    )
      this.permissionAdmin.ViewGlobalAlerts.selectAll = isEnable;

    this.selectAllGeneral();
    this.selectAllClients();
    this.selectAllGlobalAlert();
    this.selectAllGroups();
    this.selectAllKiosk();
    this.selectAllLocations();
    this.selectAllProductAndService();
    this.selectAllViewAddEditProductCategories();
    this.selectAllUsers();
  }

  changeSelectAllAdmin() {
    this.permissionAdmin.selectAllPermissionAdmin.Selected =
      this.permissionAdmin.General.selectAll == true &&
      this.permissionAdmin.Groups.selectAll == true &&
      this.permissionAdmin.Kiosk.selectAll == true &&
      this.permissionAdmin.Location.selectAll == true &&
      this.permissionAdmin.ProductAndService.selectAll == true &&
      this.permissionAdmin.Users.selectAll == true &&
      this.permissionAdmin.ViewAddEditDeleteProductCategory.selectAll == true &&
      this.permissionAdmin.ViewGlobalAlerts.selectAll == true;

    this.sectionSelectAll.emit(
      this.permissionAdmin.selectAllPermissionAdmin.Selected
    );
  }
}
